<template>
    <v-btn
        id="menuButton"
        fab
        flat
        :large="$vuetify.breakpoint.mdAndUp"
        color="red"
        icon
        to="/"
        ><v-icon>exit_to_app</v-icon></v-btn
    >
</template>

<script>
export default {
    name: 'DraftMenu'
};
</script>

<style scoped>
#menuButton {
    position: fixed;
    bottom: 0;
    right: 0;
}
</style>
